/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Live_Implausible_CeilingInputs */

const en_us2_workout_live_implausible_ceiling = /** @type {(inputs: Workout_Live_Implausible_CeilingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That's more than this kind of exercise usually takes.`)
};

const pt_br2_workout_live_implausible_ceiling = /** @type {(inputs: Workout_Live_Implausible_CeilingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fica acima do que esse tipo de exercício costuma levar.`)
};

const es_419_workout_live_implausible_ceiling = /** @type {(inputs: Workout_Live_Implausible_CeilingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es más de lo que suele llevar este tipo de ejercicio.`)
};

const pt_pt2_workout_live_implausible_ceiling = /** @type {(inputs: Workout_Live_Implausible_CeilingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fica acima do que este tipo de exercício costuma levar.`)
};

const fr_fr2_workout_live_implausible_ceiling = /** @type {(inputs: Workout_Live_Implausible_CeilingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est plus que ce que ce type d'exercice demande d'habitude.`)
};

const de_de2_workout_live_implausible_ceiling = /** @type {(inputs: Workout_Live_Implausible_CeilingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das ist mehr, als diese Art von Übung normalerweise hergibt.`)
};

const it_it2_workout_live_implausible_ceiling = /** @type {(inputs: Workout_Live_Implausible_CeilingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È più di quanto questo tipo di esercizio di solito prevede.`)
};

/**
* | output |
* | --- |
* | "That's more than this kind of exercise usually takes." |
*
* @param {Workout_Live_Implausible_CeilingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_implausible_ceiling = /** @type {((inputs?: Workout_Live_Implausible_CeilingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Implausible_CeilingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_implausible_ceiling(inputs)
	if (locale === "es-419") return es_419_workout_live_implausible_ceiling(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_implausible_ceiling(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_implausible_ceiling(inputs)
	if (locale === "de-DE") return de_de2_workout_live_implausible_ceiling(inputs)
	if (locale === "it-IT") return it_it2_workout_live_implausible_ceiling(inputs)
	return en_us2_workout_live_implausible_ceiling(inputs)
});
export { workout_live_implausible_ceiling as "workout-live.implausible_ceiling" }